export default __webpack_public_path__ + "media/pro/browser-cut-fba55fd8.svg";